import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('climas');

export const check = () => useBasicAuth.checkToken();

export const findClimaById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllClima = () => 
  axios.get(urlAPI + "/findAll" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllClimaByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllClimaByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const addClima = (obj) => 
  axios.post(urlAPI + "/addClima", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateClima = (obj) => 
  axios.put(urlAPI + "/updateClima/" + obj.clima.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteClima = (id) => 
  axios.delete(urlAPI + "/deleteClima/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



//CLIMA_CIDADE
export const findAllByClimaCidade_clima = (clima) => 
axios.post(urlAPI + "/climacidade/clima", JSON.stringify(clima), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByClimaCidade_cidade = (cidade) => 
axios.post(urlAPI + "/climacidade/cidade", JSON.stringify(cidade), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByClimaCidade = (clima, cidade) => {
let requestObj = {
  clima: clima,
  cidade: cidade
}
axios.post(urlAPI + "/climacidade", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}


//CLIMA_ESTADO
export const findAllByClimaEstado_clima = (clima) => 
axios.post(urlAPI + "/climaestado/clima", JSON.stringify(clima), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByClimaEstado_estado = (estado) => 
axios.post(urlAPI + "/climaestado/estado", JSON.stringify(estado), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByClimaEstado = (clima, estado) => {
let requestObj = {
  clima: clima,
  estado: estado
}
axios.post(urlAPI + "/climaestado", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}